import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { videoCategories, featuredVideos, hotVideos } from '@/mocks/videos';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = videoCategories.find((c) => c.slug === slug) || videoCategories[0];
  const allVideos = [...featuredVideos, ...hotVideos];
  const filteredVideos = slug === 'hot' || !slug
    ? allVideos
    : allVideos.filter((v) => v.category === slug);

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://zhainanvideo.com/' },
      { '@type': 'ListItem', position: 2, name: currentCategory.name },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="w-full px-4 md:px-6 py-4">
            <div className="max-w-7xl mx-auto">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </div>
                <span className="text-foreground-800 font-medium">{currentCategory.name}</span>
              </nav>

              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                {currentCategory.name}
              </h1>

              <div className="flex flex-wrap gap-2">
                {videoCategories.filter(c => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                      slug === cat.slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-50 text-foreground-600 hover:bg-background-200 hover:text-foreground-800 border border-background-200/60'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <section className="py-8 md:py-12 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              {filteredVideos.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                  {filteredVideos.map((video) => (
                    <Link
                      key={video.id}
                      to={`/category/${video.category}`}
                      className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                    >
                      <div className="relative w-full aspect-video overflow-hidden">
                        <img
                          src={video.cover}
                          alt={video.title}
                          title={`${video.title} - 宅男视频${currentCategory.name}在线观看`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute bottom-2 right-2">
                          <span className="px-1.5 py-0.5 bg-black/75 text-white text-[11px] rounded whitespace-nowrap">
                            {video.duration}
                          </span>
                        </div>
                        <div className="absolute top-2 left-2">
                          <span className="px-1.5 py-0.5 bg-primary-500 text-white text-[11px] font-medium rounded whitespace-nowrap">
                            {video.quality}
                          </span>
                        </div>
                      </div>
                      <div className="p-3">
                        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1.5">
                          {video.title}
                        </h3>
                        <div className="flex items-center justify-between text-xs text-foreground-400">
                          <div className="flex items-center gap-1">
                            <div className="w-3 h-3 flex items-center justify-center">
                              <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                            </div>
                            <span className="font-medium text-foreground-600">{video.rating}</span>
                          </div>
                          <span className="whitespace-nowrap">{video.source}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-200">
                    <i className="ri-vidicon-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-sm text-foreground-500">该分类暂无视频，请查看其他分类</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}